import { render, staticRenderFns } from "./DropUserOnWorkfieldModal.vue?vue&type=template&id=4ec7c63b"
import script from "./DropUserOnWorkfieldModal.vue?vue&type=script&lang=js"
export * from "./DropUserOnWorkfieldModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports